import { AxiosError } from 'axios'
import { forceLogout } from 'utils' // ✅ Now it works like the other imports
import { __DEV__ } from '../constants'
import { ServerError } from '../types/common'

export function errorHandler(error: AxiosError<ServerError, any> | undefined, message?: string) {
	if (!error) {
		return error
	}

	// ✅ Handle unauthorized access from dashboard
	if (error?.response?.status === 401) {
		const url = error?.config?.url || ''
		const isAuthEndpoint = url.includes('/api/token/')

		if (!isAuthEndpoint) {
			if (__DEV__) {
				console.warn('401 from protected route — forcing logout...', url)
			}
			forceLogout()
			return null
		}
	}

	if (__DEV__) {
		console.error(error)
	}

	let errorMessage: string = ``
	let errorMessageFieldNames: string = ``

	try {
		if (typeof error?.response?.data === `string`) {
			errorMessage = error?.response?.data
		}
	} catch (error) {
		console.trace(error)
	}

	try {
		if (!errorMessage) {
			errorMessage = Object.values(error?.response?.data)
				.map((v) => v)
				.join(`, `)
		}
	} catch (error) {
		console.trace(error)
	}

	try {
		// @ts-ignore
		errorMessageFieldNames = Object.keys(error?.response?.data).map((v) => v)
	} catch (error) {
		console.trace(error)
	}

	if (errorMessage) {
		return {
			// @ts-ignore
			error: error.response?.data?.code ?? error?.response.status,
			message: message ?? errorMessage,
			errorMessageFieldNames,
		}
	} else if (error.response) {
		return {
			error: error.response?.data?.code ?? error.response.status,
			message: message ?? error.response.data.message ?? error.response.statusText,
			errorMessageFieldNames,
		}
	} else if (error.request) {
		return {
			error: 500,
			message: message ?? `Request was made but no response received`,
			errorMessageFieldNames,
		}
	} else {
		return {
			error: 500,
			message: message ?? `Something else happened while setting up the request`,
			errorMessageFieldNames,
		}
	}
}
